<shared-ceops></shared-ceops>

<div id="app-container" class="product-container" role="main" itemscope itemtype="http://schema.org/Product">
	<router-outlet></router-outlet>
</div>

@if (feedbackSurveyEnabled && enableFeedback) {
	<div id="feedback-container-bottom">
		<pdp-feedback [formId]="feedbackSurveyId"></pdp-feedback>
	</div>
}
